import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../../createApiConfig';

export const dMIpAddressApi = createApi({
  reducerPath: 'dMIpAddressApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['IPAddress', 'FailedIPAddress'],
  endpoints: (builder) => ({
    getIpAddresses: builder.query({
      query: (params) => ({
        url: `/domains/ip-addresses/`,
        params,
      }),
      providesTags: ['IPAddress'],
    }),

    
    createIpAddress: builder.mutation({
      query: (data) => ({
        url: '/domains/ip-addresses/',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['IPAddress'],
    }),
    
    getIpAddressById: builder.query({
      query: ({ id, relations }) => ({
        url: `/domains/ip-addresses/${id}`,
        method: 'GET',
        params: { relations },
      }),
      providesTags: ['IPAddress'],
    }),
    updateIpAddress: builder.mutation({
      query: ({ id, body }) => ({
        url: `/domains/ip-addresses/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['IPAddress'],
    }),

    deleteIpAddress: builder.mutation({
      query: (id) => ({
        url: `/domains/ip-addresses/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['IPAddress'],
    }),

    
  }),
});

export const {
  useGetIpAddressesQuery,
  useLazyGetIpAddressesQuery,
  useGetIpAddressByIdQuery,
  useCreateIpAddressMutation,
  useUpdateIpAddressMutation,
  useDeleteIpAddressMutation,
} = dMIpAddressApi;
